<!--
 * @Author: 朱元培 zhuyp41266@hundsun.com
 * @Date: 2023-06-19 10:21:52
 * @LastEditors: 朱元培 zhuyp41266@hundsun.com
 * @LastEditTime: 2023-09-25 20:46:26
 * @FilePath: \deal\src\components\bar\main-navbar.vue
 * @Description: 公共头部
-->
<template>
  <div class="nwt-navbar main-top">
    <img class="logo-img" :src="logoUrl"/>
    <div class="top-mes" v-html="customerHotline"></div>
    <div class="top-button">
      <p class="cursor-p" style="display: inline-block;" v-html="officialWebsite"></p>
      <template v-if="!userInfo.clientid">
        <!-- <span class="top-span" @click="goLogin">登录</span>
        <span class="top-span" @click="goRegister">注册</span> -->
      </template> 
      <template v-if="userInfo.clientid">
        <span class="split-span" >|</span>
        <h-poptip id="loginOut" class="cursor-p" content="退出登录" placement="bottom-end">
        <img :src="require(`../../assets/img/${userInfo.accountInfo?.sex=='1'?'male':'female'}.svg`)" />
        {{!userInfo.noHasAccount?userInfo.accountInfo.custname:userInfo.mobile}}
        <h-icon name="unfold"></h-icon>
      </h-poptip>
      </template>
    </div>
  </div>
</template>

<script>
  import http from '@/assets/utils/httpRequest'
  import storage from '@/assets/utils/ss';
  import { getLogoUrl, getCustomerHotline, getOfficialwebsite, getWebsiteIcon } from '@/assets/utils/find-component';
  import {
    mapGetters
  } from 'vuex';
  export default {
    props: {

    },
    data() {
      return {
        userInfo: {},
        indexInfo: window.config.clientIndex,
      };
    },
    computed: {
      // ...mapGetters(['userInfo']),
      logoUrl() {
        return getLogoUrl();
      },
      customerHotline() {
        return getCustomerHotline();
      },
      officialWebsite() {
        return getOfficialwebsite();
      },
      websiteIcon() {
        return getWebsiteIcon();
      }
    },
    created() {
      document.querySelector('link[rel="shortcut icon"]').href = this.websiteIcon;
    },
    mounted() {
      var _this = this
      $('#loginOut .h-poptip-body').click(function () {
        http.post(config.apiURL + '/account/login/logout', {
          channel: 'web'
        }).then(res => {
          if (res.code == 0) {
            _this.$store.dispatch("main/getIsLogin", false);
            _this.$store.dispatch('user/getUserInfo', {})
            _this.$router.push({
              path: '/login'
            });
            storage.removeItem('fundBaseInfo', {});
          }
        })
      })
    },
    watch: {
      '$store.state.user.userInfo': {
        handler: function (newVal, oldVal) {
          this.userInfo = newVal
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      goIndex() {
        window.open(config.indexUrl)
      },
      goLogin() {
        this.$router.push({
          path: '/login'
        });
      },
      goRegister() {
        this.$router.push({
          path: '/forget/creatAccount'
        });
      },
    },
    components: {

    }
  };
</script>

<style scoped lang="scss">
@import '@/assets/scss/theme.scss';
  .main-top {
    position: relative;
    // position:fixed;
    box-shadow: 0px 4px 10px 0px rgba(78, 89, 105, 0.06);
    display: flex;
    align-items: center;
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    z-index: 999;
    box-sizing: border-box;

    .logo-img {
      margin-left: 24px;
      height: 80%;
    }

    .top-mes {
      margin-left: 80px;
    }

    .top-button {
      box-sizing: border-box;
      position: absolute;
      right: 24px;

      span {
        cursor: pointer;
        font-size: 16px;
        color:$main-color-tone;;
        font-weight: 400;
        margin-right: 16px;
      }

      img {
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }

      .top-span {
        display: inline-block;
        border-left: 1px solid #F0F0F0;
        padding-left: 16px;
      }

      .split-span{
        margin: 0px 16px;
        color: #F0F0F0;
      }

      ::v-deep .h-poptip-inner {
        min-width: 88px;

        .h-poptip-body {
          width: 100%;
          min-height: 60px;
          line-height: 60px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;

          .h-poptip-body-content-inner {
            font-size: 14px;
            color: #333333;
            min-height: 22px;
          }
        }
      }

      ::v-deep a {
        color: $main-color-tone;
      }
    }

  }
</style>